// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__398Q6","userName":"UserMenu_userName__3K3zK","userAvatar":"UserMenu_userAvatar__32APO"};